import React, { Component } from 'react';
import { Translation } from 'react-i18next';
import { Card, Col, Row, Space, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { Redirect } from 'react-router-dom';
import { pathTo } from '../../../Routes';
import {
  hasPermissionAdmin,
  pathRedirect,
} from '../../../elements/lib/hasPermissionAdmin';
import { getRouteFromPath } from '../../../Routes';
import RegistrationCodesList from '../containers/RegistrationCodesListContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Config from '../../../../../Config';
import QueryString from '../../../../../lib/QueryString';
import Logger from '../../../../../lib/Logger';
import { MixpanelTracker } from '../../../../../lib/Mixpanel';

class RegistrationCodesScreen extends Component {
  static defaultProps = {
    limit: Config.get('DEFAULT_LIST_LENGTH', 10),
    isLoading: true,
  };

  state = {
    redirect: null,
  };

  trackerActions = (eventMixpanel, params = {}) => {
    if (this.props.role !== 1) {
      MixpanelTracker.mixpanelTrack(eventMixpanel, {
        partnershipName: this.props.partnershipName ?? 'No partnership',
        partnershipId: this.props.partnershipId ?? 'No partnership',
        ...params,
      });
    }
  };

  scrollToTop = () => {
    Logger.log('debug', `RegistrationCodesScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  };

  render() {
    const loadingIcon = (
      <Spin indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />} />
    );
    const page = parseInt(
      this.props.match.params.page ? this.props.match.params.page : 1
    );
    const { order, ...filter } = QueryString.parse(this.props.location.search);
    const pageUserProfilePartnership = parseInt(
      this.props.match.params.page_partnership
        ? this.props.match.params.page_partnership
        : 1
    );

    const { redirect } = this.state;

    if (redirect) {
      return <Redirect to={pathTo(redirect)} />;
    }

    return (
      <Translation>
        {(t) => (
          <div>
            <DocumentHead title={t('registration_codes_route_list')} />

            <Row>
              <Col span={24}>
                <Card
                  title={
                    <Space size={10}>
                      {t('registration_codes_list_title')}
                    </Space>
                  }
                  extra={this.props.isLoading ? loadingIcon : null}
                >
                  <RegistrationCodesList
                    key={page}
                    component='RegistrationCodesScreen'
                    page={page}
                    limit={this.props.limit}
                    order={order || 'updated_at.desc'}
                    filter={filter}
                    pageUserProfilePartnership={pageUserProfilePartnership}
                    trackerActions={this.trackerActions}
                  />
                </Card>
              </Col>
            </Row>
          </div>
        )}
      </Translation>
    );
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }

  componentDidUpdate(prevProps) {
    const route = getRouteFromPath(this.props.location.pathname);
    const screen = hasPermissionAdmin();
    if (
      this.props.partnershipId !== prevProps.partnershipId &&
      route.screen !== pathRedirect(screen)[0]
    ) {
      this.setState({ redirect: pathRedirect(screen)[0] });
    }
  }
}

export default RegistrationCodesScreen;

Logger.log('silly', `RegistrationCodesScreen loaded.`);
